export const storyContent = `> "What glitters and glistens without a stain, oft bindet mit Wurzeln ungesehn."

Ever dream of a land and place, so utterly spellbinding, exceedingly bountiful, inhabited by those that welcome with open arms, devoid of frost or drought, free of sorrow, empty of strife? A stretch of land that beggars belief in how quickly it disarms and unwinds. Akin to a warm embrace, from which few could fathom the thought of escaping.

Such is Graengale Grove. With its morning wonder, und seiner nächtlichen Bindung.

Hast du jemals von einem Land geträumt, dem du nicht entfliehen **kannst**? Ein Land, das dich verändert? Stark und unveränderlich, dass du keine Hoffnung hast zu überwinden. Starrer als die Wurzeln, und unaufhörlich bindend. Erstickend und entziehend deine Essenz, und dann verwandelt es dich in sich selbst. Wie ein kalter Griff, von dem wenige entkommen.

Solch ist Graengalen Gehölz. Mit seiner nächtlichen Bindung, and its morning wonder.

There I went, lured by beauty, und dort verbleibt ein Teil von mir, für immer gefangen.

## Light

Corrupt thoughts often seep in at the height of purity; the desire for misdeeds intensifies within those moments. And then all that is needed is a lull, a passing moment where one's guard is lowered, and when boredom ignites those festering thoughts. Suddenly, the grove we had been barred entry to became the object of my curiosity, and what began as a peek, then slid into a peer, then continued into a look around the extremities of the grove.

It appeared as normal as any patch of land tended to by my kin, indeed, wood elves did not leave the land ailing. As idyllic as the rest of my forest, and as welcoming. Warmth extended to my every step, a gentle rustling of the leaves as if beckoning me in, and to its song I did hearken.

The deeper my bare feet took me, the wilder the forest became. Not in a dangerous sense, no. Rather, in its fierce, untamed beauty. There were no paths here, no broken twigs or cultivated branches; there was only raw, unbridled, verdant excess. A proclivity for life that was unrivalled, even in the deepest confines of my people's forest.

Deeper still I wandered, looking this way and that, admiring everything from the sway of massive branches overhead, to the certainty of stems and roots that lifted this canopy above, to the silky touch of grass beneath me that almost whispered.

That almost spoke to me…

That…

_"Sister dearest in our wood,"_ I heard, in a tongue familiar to my ears.

_"Sister with no fear in heart,"_ silken voices called out to me, far fairer than my people's.

_"Traveller where none else would,"_ their dulcet voices continued.

_"Traveller gentle, kind, und zart."_

I stopped at the last word, for I did not know it but I understood it. In fact, the more I focused, and the more they went on with their song, the more I realised I could not hear them, but their song echoed in my ears. And then, in the faint rays of light that scattered into the grove, I beheld them but without seeing them.

Fairer than any of Caiden's creatures, and wreathed in its nature. Light struck them and their skin glowed in a brilliant sheen, their hair long and silken, their features carved as though of naught but wind and water. And their garb, oh their garb was unlike any I had seen. Leaves and roots, branches and twigs, living as it encompassed them, and descending as skirts of vines into the land itself. They did not walk as I did, they seemed to effortlessly glide along the land towards me. And they wore faint reassuring smiles upon their lips, no gaudy grin, no baleful beam.

"Who are you?" I asked out of instinct.

"We are you, and you are we," one replied, and I frowned.

I looked behind to search for the way back, but there was only forest. Then I looked ahead and I could not see them, instead, the world before me had changed. I saw a silver stream wind along ahead of me, and before it there was a cairn. The stream's path split left and right, but water only went right by the cairn, and so I approached it and stood by it for a moment.

"Come to us, sister. Come to those your kin have left behind."

My hands moved on their own, as though guided by unseen forces, and I was made to grip a long stone atop the cairn, pointing right.

"Die Wahl is yours, as immer es war."

The choice was mine, and choose I did. I turned the stone with great effort, and watched as the water shifted course, going from right to left, glowing in brilliant hues as the canopy of trees above withdrew, as I beheld a world within our own with a thin shimmering veil separating me from that land that was bliss incarnate.

Rivers flowed beyond gardens and vales, brushed by soft gales. The sun high in the sky that was painfully blue and bright, a land of utmost serenity, a place that drew me in, that made me forget I was ever a part of the world. I stepped forward hastily into that thin veil, wanting to join the land of the Elder Elves.

And as soon as I did, the veil wrapped around me, once, twice, thrice, until I could see no more. Until I was cocooned. Until the light died with me.

## Dämmerung

Als ich erwachte, war die Welt ein wenig dunkler geworden.

"Wo bin ich?" fragte ich, aber ich wusste nicht, wen ich fragte. "Das Land der uralten Elben?"

Ich stand auf und ich hörte Rascheln überall. Meine Kleider waren verschwunden, an ihrer Stelle lagen Blätter und Zweige. Ich versuchte zu gehen, und wie die uralten Elben schwebte ich über den Boden. Erst dann bemerkte ich, dass ich in ihrer Sprache sprach.

Verwirrt hob ich den Blick; dort lag der Fluss, dessen silbernes Wasser nahe in diesem dämmrigen Licht glitzerte. Als ich ging, verflochten sich meine Wurzeln mit dem Gras und fühlten sich ruhig an. Viele kleine Lichtfunken flogen aus dem Gras, nur um wieder zu sinken. Mit jedem Funken schlossen sich meine Augen, langsam, unaufhaltsam.

"Willkommen in Kai'denn, Valora." Eine Stimme rief mir zu. "Deine erste Zeit, aber zu spät."

"Spät? Wartetest du auf mich?" fragte ich, als ich den Mann erblickte. Er glich den Elben aus dem Gehölz, aber ursprünglicher, mehr Baum als Mann. Seine Haut war gesplittert und rissig, seine Augen sahen aus, als ob sie in Harz schwammen, und sein Haar war wie Baumblätter.

"Natürlich warteten wir darauf, dass du heimkehrst."

"Heim? Tut mir leid, aber das ist nicht mein Heim."

"Wieso? Kai'denn ist unser aller Heim. Und in diesen Tagen braucht unser Heim uns."

Noch einmal sah ich zurück, und der Weg war verschwunden.

"Ich verstehe," murmelte er mit einem erschöpften Seufzer. "Du hast deine Heimat verloren und sie vergessen, wie so viele. Möchtst du dass ich dir den Weg weise? Ich verstehe-"

"Warte, bitte…" fiel ich ihm ins Wort. "Sag mir, was mein Heim von mir braucht?"

"Nur deine Zeit." Eine hoffnungsvolle Miene legte sich auf sein Gesicht.

"Dann zeig mir!" sagte ich, und ich konnte hören, wie seine Haut mit einem Lächeln knarzte.

Er hob seine Hand, und ein Sternenregen ergoss sich über mich. Das Licht fühlte sich kühl an, friedvoll. Selig. Doch der Mann war bereits verschwunden.

"Warte…" sagte ich, als wir in die Nacht wanderten.

## Nacht

Lange Zeit gingen wir in die Nacht. Es war unglaublich, als wir gingen, wurde es dunkler. Doch als wir anhielten, hielt das Licht an. Als blieben di Sonne und der Mond im Himmel. Bewegunglos.

"Siehst du den Baum?" fragte er.

"Welchen?"

Erst dann erkannte ich ihn. Was ich für einen riesigen Schatten gehalten hatte, war ein Baum; der größte, den ich je gesehen hatte. Nicht bloß ein Baum, sondern etwas Unvorstellbares. So breit wie der Horizont, höher als der Himmel selbst. Seine Rinde zeigte Rillen wie Bergkämme, und endlose Flüsse strömten durch seine Adern, hin_auf_ in sein Herz.

Doch er war… verwelkt.

"Siehst du jetzt?"

"Was **ist** das?!"

"Das Herz unserer Heimat. Nein, nicht nur. Das Herz der Welt."

"Aber dann… warum ist es verwelkt?"

"Nicht verwelkt, sondern verloren."

Er sagte nichts mehr, aber ich begriff.

"Wie kann ich helfen?"

"Allein? Weiß ich nicht. Aber komm."

Um uns glitzerten die Flüsse, selbst im Dunkeln, als schienen Schatten auf sie herab. Sie strahlten violette Energie aus, die von Schwarz und Blau durchzogen war. Das Wasser stand gefährlich niedrig, als wäre das, was einst hinaufgeflossen war, längst verloren.

Dennoch gingen wir weiter in die betäubende Leere. Unsere Wurzeln machten den Aufstieg mühelos. Bald schon folgten wir den kammartigen Strukturen, die den Stamm säumten. Sie waren so gewaltig, dass man ihn für einen Berg halten könnte. Je höher wir stiegen, desto mehr enthüllte sich von der Landschaft dieser ätherischen Welt.

Das Land um den Baum lag in ewiger Nacht gehüllt, während der äußere Rand im Sonnenlicht badete.

Doch die Nacht hier war nicht kälter als der Tag, und beide waren gleichermaßen fesselnd.

Stunden vergingen, bis wir schließlich in eine Baumhöhle eintraten. Dort flackerte ein Licht auf, das mich von meinem neuen Gefährten zurückweichen ließ. Sein Antlitz hatte sich völlig verwandelt. Alle Spuren elfischer Züge waren wie ausgelöscht. Dennoch bewegte er sich unverändert, verhielt sich nicht fremder als zuvor.

Tatsächlich hatte er meine Reaktion bemerkt.

"Keine Sorge," sagte er. "Hier tragen wir das Licht."

"Dann… ist das deine echte Gestalt?"

"Meine natürlich Gestalt, ja."

"Bist du wirklich ein Elf?"

"Das sollte ich eher dich fragen."

Dann hörte ich ein stärkeres Knarzen, als ob Holz brechen und zersplittern würde.

_"Sister gekleidet in unsere Tracht,"_ hörte ich, in vertrauter Zunge.

_"Schwester furchtlos in voller Macht,"_ riefen seidene Stimmen mir zu, weit lieblicher als die meines Volks.

_"Träumerin, Träumerin wo wenige es wagen,"_ fuhren ihre samtenen Stimmen fort.

_"Träumerin, Träumerin, Lebensblut das Welten tragen."_

Meine eigenen Wurzeln umschlangen mich fest. Meine Kleidung erstickte mich.

Und dann sah ich sie.

Drei uralte Elben stiegen um uns herab, als ob sie aus dem Herzen des Baumes kämen.

"Sie kommt in Frieden!" sagte mein Freund. "Lass sie los!"

"Es gibt keinen Frieden hier, Junge."

Ein Mann, ein Dame, und ein älterer Mann. Alle drei waren auch mehr Baum als Mensch. Aber mehr als mein Freund, und sie waren in Schatten gehüllt.

"Sie und ihresgleichen," sagte die Frau. "Nicht meine Kinder. Nicht mehr."

"Sie haben unsere Welt ins Verderben gestürzt!" sagte der Mann.

"Sie haben unsere Welt vergessen, und brachten so Dürre!" sagte der ältere Mann.

"Sie ist nicht wie ihresgleichen!" antwortete mein Freund.

Schließlich konnte ich aufatmen.

"Wie so?"

"Sie hat ihre Traumessenz freiwillig gegeben!"

Was auch immer er gesagt hat, es hat funktioniert. Die Wurzeln entspannten sich, und kamen wieder unter meine Kontrolle.

"Echt?"

Mit erhobener Hand zog er magische Filamente aus mir, und ihre Gesichter entspannten sich.

"Sie mag nur helfen," sagte mein Freund.

Dann öffnete sich die Baum.

Die Äste schwangen weit aus, die schattigen Blätter teilten sich, und ich sah, wie sich das Land vor mir wieder ausdehnte. Diesmal sah ich am Ende eine Mauer. Eine massive, gespenstisch weiße Mauer, um die ein breiter Fluss floss.

"Filivindabair die Faire, Mutter der Natur, zu Ihren Diensten."

"Milihaniel der Weise, Vater der Magie, zu Ihren Diensten."

"Istellinith der Starke, Vater des Landes, zu Ihren Diensten."

Diese Namen…

"Filivindabair? Milihaniel? Nein… Und Istellinith? Das sind die Götter! Aber Sie sehen ihnen überhaupt nicht ähnlich."

Mit einem Lächeln hob Filivindabair ihre Hände, und sie brachte Sonnenschein um uns. Und dann sah ich…

Eine schöne Elfe mit langem, braunem, seidigem Haar. Grüne Augen, und eine Aura des Lebens und Liebe für alles Lebendige. Dann ein gut aussehender Elf mit Magie über ihm. Und dann ein älterer Elf, blasse Haut und fest aussehend.

"So kennst du uns. Kind der Nachkommenrassen." sagte Istellinith.

"Und wir sind nicht Götter, nur Elben wie du."

"Was zeigen Sie mir?" sagte ich.

"Eine vergehende Welt." Kam die Antwort.

"Valora… _Elderleaf_. Möchtest du wirklich dieser Welt helfen? Diese Flüsse sind ausgetrocknet. Das Wenige, das von ihnen übrig geblieben ist, fließt nicht zum Herzen, sondern zu einer Mauer aus Lügen…"

"Nimm diesen Stein."

"Stein?" sagte ich, "Oh, wie von den Steinhaufen?"

Ich nahm den Stein, und plötzlich sah ich die Drei nicht mehr. Nur mein Freund blieb.

"Weißt du was du machen musst?"

Ich nickte, dann lasse ich mich von meinem Freund zurückführen

Und wieder reisten wir diesmal um den gewaltigen Baum. Als sich meine Augen mehr an die Dunkelheit gewöhnten, sah ich, was wie Risse und Spalten im Gewebe dieser Welt aussah. Sie nannten es Kai'denn, aber ich fühlte, dass ich es unter einem anderen Namen kennen würde. Dennoch ging ich mit ihm weiter, bis wir schließlich einen Arm des Flusses erreichten, den ich als meinen eigenen kennengelernt hatte. Ich hatte das Wasser bereits zuvor umgeleitet, damit es in diesen Ort fließt, und nun sah ich, dass es vom Baum zur Mauer abgeleitet wurde.

Und da sah ich ihn. Einen zweiten Steinhaufen. Dem der Stein fehlte, der in meiner Hand war.

"Valora... es gibt etwas, das du wissen musst."

Ich hielt inne.

"Solltest du tun, was die Vorväter von dir verlangen, wirst du nicht in deine Welt zurückkehren. Und... ich weiß nicht, ob dein Opfer etwas bewirken wird."

Diese Worte zu hören zerbrach etwas in mir, aber ich war hier gewesen, ich hatte gesehen, was ich sah, ich war mit der Welt auf eine Weise verbunden gewesen, die ich nie für möglich gehalten hatte... Ich wusste, dass dies getan werden musste. Ich fühlte ein Gefühl von Bestimmung, das mir mein ganzes Leben lang entgangen war.

Und so näherte ich mich dem Steinhaufen.

"Leb wohl, Freund."

Und ich legte den Stein nieder und drehte mich um.

Und die Welt wurde dunkel.

## Dunkel

Ich wachte allein auf, mit dem Stein in der Hand und dem Rücken zum Baum. Dann fühlte ich Magie, ein Zauber, der mich belebte. Auch kein unbekannter Zauber.

Erschöpft kroch ich zu einem nahen Fluss, vom Zauber getrieben, daraus zu trinken. Als das Wasser meine Lippen berührte, fühlte ich mich belebt, meine Wurzeln genährt, meine Blätter belebt. Ein kühler Wind drückte auf mich und lenkte mich zur Sonne hin, flehte mich zu gehen… doch er war schmerzerfüllt.

Wortlos wanderte ich, neben dem Fluss. Als ich meine Reflexion erblickte, erschrak ich. Zwei von mir, übereinander gelegt, starrten zurück. Nicht mehr war ich ganz.

Lautlos wanderte ich aus der Dunkelheit into a new dawn.

## Dawn

Cairn stone in hand I ventured towards sun-touched lands once more. Again I paused looked back at the tree, whose enormity still boggled my mind. And again, whenever I would step back towards it, the sun that had begun to rise would set once more. As though whichever direction I walked moved time in a different way.

"Fairest maiden, I do not believe I have had the pleasure," a genlte voice echoed around me, and soon after an elf of these lands made himself known to me. "Could it be? A dreamer in this age?"

"A dreamer?" Another voice skipped along the river, then from it emerged and approached me from a different side. "A child of Filivindabair no less!"

"Why now? Why alone?" Another voice crept upon me, three now surrounded me of these elves of a bygone age.

"I…" My voice left me as I tried to speak.

"She is winded, a true dreamer then."

"But if so, then why does she bear the mark of a drinker?"

"And the winds seem to carry her… elsewhere."

"Forgive me," I finally managed. "I do not have my full wits about me, why is it that you call me a dreamer?"

The one that had given me the title offered me a reassuring smile.

"Because that is precisely what you are, dearest whose name eludes us."

"Valora," I replied plainly.

"Well then, Valora, your name must be remembered. For in an age when none dare dream, here you are."

"Indeed, this land was once rife with dreamers. A vivid concourse for elven spirits to tend to the world, and in turn tend to themselves. But alas such an age has long since expired."

"Now, they come not to us, but to that dreadful wall and no nearer, that is when they slumber at all."

"You mean..." Suddenly it all made sense. "But how? We were taught that should we slumber never to venture into the gate, that only foolish elves that wish to lose themselves give in to the temptation of the gate... Am I now inside?"

"Sweetest Valora, whomever taught you that, or rather whomever taught your kind such nonsense has taught you how to gently snuff out the world."

"But how can that be, when I have done naught in my time here?"

"You need only come, that is why we are here, to ensure that your spirit is sated. To ensure that a part of you trickles into the world and keeps it rejuvenated."

"Then... surely I must stay." I decided.

"No, surely you must leave."

"Indeed, but surely you must return again. Every night."

"And undo the wrong that has been done. You alone would fade before a single grove has been healed in our ailing world. Elf-kind must return to Kai'denn."

My expression soured, but I knew what they said to be the truth. And it was then that I had arrived at the gate. I exchanged longing glances with those that had accompanied me, then I blurted out with emotion.

"Come with me then! Let me show my kin what they are missing behind the gate!"

"Dearest Valora, only you may pass."

Just as I heard these words, the gate creaked open, a gate made of ornate wood, vines, and leaves that just unraveled at my approach, and there again I saw that thin veil. But I could not go through, not yet.

"Go, Valora. We shall await your return."

"And the return of the offspring races."

"As we have awaited for millennia."

And so, I plunged myself again into the veil.

And all I could see was the fierce gaudy light of the morning sun.

## Morning

Gasping and choking for air I awoke.

I could scarcely open my eyes as I struggled for breath.

In my hand I felt the cairn stone still there, and so I used it. Hacking away at my cocoon, furiously ripping and tearing at it until I collapsed into the grove where I had been seemingly days ago.

"Why... do I feel as though the weight of the world..."

I could not move an arm nor lift a finger, I could not push myself up nor do much more than wallow there between fallen leaves and sinister roots.

"No... not again..."

Sleep called to me, but instead I mustered my strength and dragged my lifeless husk of a body along the river, towards the cairn, but I could only manage an inch before I fell flat again. Stone still in hand, eyes closing.

Drifting. Losing myself again.

I felt empty. Hollow. Incomplete.

I heard the river rushing around me, I heard shifting roots approach me, and then the stone was taken from my hand. I gasped and choked but could do no more as I heard the river rush once more, shifting course again, before I heard footsteps now.

"Finnabin Glaeth! What are you doing there?" I heard the voice, along with the colorful elven words directed at me. "No one is allowed here! Come!"

And then, as the Grove Guard carried me, I fainted once more, falling into slumber.

And there I saw it again, from the other side, the gate that I now knew what lay behind.

Wearily I approached the gate, ignoring the tap next to it that I would drink from. But it did not open for me, not this time. Instead I felt something, or someone, or something eerily familiar call out to me from the other side.

I put my hand on the gate, and it did the same, and only then I understood.

Part of me was forever trapped there. Lost. Fractured and entombed there in Urkai'denn.

Such was my toll, to live as a husk, until I could guide my kind back home.

Until the world itself would become whole again.

Such indeed, was Graengale Grove.`;

export const balladLyrics = `Come wanderer to verdant lands so fair,
Where morning sun illuminates the air,
The Grove extends its welcome without guile,
Where gentle leaves embrace you for a while.

Komm Träumer in die Dunkelheit hinein,
Wo Wurzeln dich umschlingen, Stein bei Stein,
Der Baum erhebt sich endlos in die Nacht,
Und hält dich fest mit uralter Macht.


The river sings with silver voice so bright,
It winds through gardens bathed in golden light,
The Elder Folk walk gracefully along,
Their beauty woven into nature's song.

Der Fluss versiegt, die Adern trocken, leer,
Das Herz des Baumes schlägt nicht mehr,
Die Ahnen warten, Schatten ohne Ruh,
Und rufen deine Seele zu sich zu.


I stepped beyond the gate with willing heart,
To join the bliss where sorrow finds no part,
The cocoon wrapped me soft as mother's hand,
And drew me into that enchanted land.

Gefangen in der Hülle, schwarz wie Tod,
Die Finsternis erstickt das Morgenrot,
Ich wachte auf, geteilt und unvollständig,
Ein Teil von mir für immer dort gefänglich.


And still I walk beneath the sun's bright rays,
But half of me remains in darkened maze,
For Graengalen demands its gentle toll.
The Grove that keeps a fragment of your soul.

Und noch ich wandle durch Urkai'denn's Reich,
Die Hälfte fehlt, ich bin nicht mehr dergleich,
Denn Graengale verlangt sein stilles Pfand.
Das Gehölz, das hält was es empfand.


_So learn from one who crossed the veil between:_
_What glitters bright conceals what lies unseen._

_So lerne von der einen, die durchschritt:_
_Was außen lockt, nimmt innen dich damit._`;
